export default {
  title: {
    en: 'Recommendations Just&nbsp;For&nbsp;You',
  },
  tagText: {
    en: `
      It looks like you enjoy {isMale, plural, one {colognes} other {perfumes}}
      with <span>{tag}</span> notes
    `,
  },
  text: {
    en: 'Here are other products that someone with your&nbsp;great&nbsp;taste&nbsp;would&nbsp;LOVE:',
  },
}
